const pillars = [
  {
    icon: "ri-lightbulb-line",
    label: "Honest",
  },
  {
    icon: "ri-heart-line",
    label: "Encouraging",
  },
  {
    icon: "ri-anchor-line",
    label: "Grounded",
  },
  {
    icon: "ri-group-line",
    label: "For Everyone",
  },
];

export default function PodcastMission() {
  return (
    <section className="bg-cream py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-start">

          {/* Left — label + heading + pillars */}
          <div className="lg:col-span-4">
            <span className="font-sans text-xs font-semibold tracking-widest uppercase text-amber-600 block mb-4">
              Our Purpose
            </span>
            <h2 className="font-serif text-4xl lg:text-5xl font-bold text-amber-900 leading-tight mb-10">
              Why The Humble Machine Exists
            </h2>

            {/* Pillar badges */}
            <div className="flex flex-col gap-4">
              {pillars.map((p) => (
                <div
                  key={p.label}
                  className="flex items-center gap-4 bg-amber-50 border border-amber-100 rounded-xl px-5 py-3"
                >
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-amber-100 flex-shrink-0">
                    <i className={`${p.icon} text-amber-700 text-lg`} />
                  </div>
                  <span className="font-sans text-sm font-semibold text-amber-800">{p.label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right — long-form text */}
          <div className="lg:col-span-8 lg:pt-16">
            <div className="border-l-4 border-amber-400 pl-8 mb-10">
              <p className="font-serif italic text-amber-800 text-xl lg:text-2xl leading-relaxed">
                "This podcast was born out of a simple belief — that everyday people deserve an honest, encouraging, and grounded conversation about one of the most powerful forces shaping our world right now."
              </p>
            </div>

            <div className="space-y-6 font-sans text-base text-stone-600 leading-relaxed">
              <p>
                AI is a tool. One of the most powerful tools humanity has ever created. And like every powerful tool in history — from the printing press, to electricity, to the internet — <strong className="text-amber-900">what it becomes depends entirely on the people who use it and the values they carry into it.</strong>
              </p>
              <p>
                Most conversations about AI happen in boardrooms, on tech blogs, or between people who already understand the landscape. Meanwhile the people whose lives are being most directly shaped by it — workers, parents, small business owners, communities of faith — are left to figure it out on their own.
              </p>
              <p>
                That's why this moment calls for humble, thoughtful, informed people to step up and engage. Not from a place of fear. Not from a place of hype. But from a place of genuine care for people.
              </p>
              <p>
                The Humble Machine is our answer to that calling. A space where curiosity is welcome, questions are honored, and the conversation is always aimed at your real life — not some abstract future.
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
